module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/cards/',
        query: _vm.backQuery
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (this.$route.query.cardID == undefined) ? _c('h2', {
    staticStyle: {
      "margin": "0 0 30px 0"
    }
  }, [_vm._v("Ez a felület a kártyarendszerben nem létező kártyák felvitelére szolgál, csak kivételes esetekben ajánlott a használata!")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.szakok.length > 0) ? _c('ul', {
    staticClass: "list-with-icon"
  }, _vm._l((_vm.szakok), function(szak, i) {
    return _c('li', [(szak.statusz == 'Aktív') ? _c('i', {
      staticClass: "icon fa fa-check-circle",
      staticStyle: {
        "color": "green"
      }
    }) : _vm._e(), _vm._v(" "), (szak.statusz != 'Aktív') ? _c('i', {
      staticClass: "icon far fa-times-circle",
      staticStyle: {
        "color": "#d6e1e5"
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(szak.szak) + " (" + _vm._s(szak.szakkod) + ") - " + _vm._s(szak.tagozat) + "\n              ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": this.$route.query.cardID != undefined,
      "id": "owner_name",
      "label": "Tulajdonos",
      "errors": _vm.errors,
      "name": "owner_name"
    },
    model: {
      value: (_vm.form.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "owner_name", $$v)
      },
      expression: "form.owner_name"
    }
  }), _vm._v(" "), (_vm.up_email != '') ? _c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "up_email",
      "label": "E-mail cím",
      "name": "up_email"
    },
    model: {
      value: (_vm.up_email),
      callback: function($$v) {
        _vm.up_email = $$v
      },
      expression: "up_email"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.email != '') ? _c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "email",
      "label": "E-mail cím",
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.query.cardID != undefined) ? _c('inputbox', {
    attrs: {
      "disabled": "",
      "id": "card_number",
      "label": "Kártyaszám",
      "errors": _vm.errors,
      "name": "card_number"
    },
    model: {
      value: (_vm.form.card_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_number", $$v)
      },
      expression: "form.card_number"
    }
  }) : _vm._e(), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": this.$route.query.cardID != undefined,
      "id": "rf_id",
      "label": this.$route.query.cardID != undefined ? 'RF ID' : 'RF ID (Beolvasáshoz érintse a kártyát az olvasóhoz)',
      "errors": _vm.errors,
      "name": "rf_id"
    },
    model: {
      value: (_vm.form.rf_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "rf_id", $$v)
      },
      expression: "form.rf_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Rendszámok")]), _vm._v(" "), _vm._l((_vm.form.plates), function(plate, index) {
    return _c('table', {
      key: 'plateid:' + plate.id
    }, [_c('tr', [_c('td', [_c('inputbox', {
      attrs: {
        "id": 'plate-' + index,
        "name": "'plate-' + index",
        "errors": _vm.errors
      },
      model: {
        value: (plate.number),
        callback: function($$v) {
          _vm.$set(plate, "number", $$v)
        },
        expression: "plate.number"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [(!plate.active_season_ticket) ? _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.deletePlate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _c('i', {
      staticClass: "fa fa-exclamation-circle fa-lg",
      staticStyle: {
        "color": "#C25450"
      },
      attrs: {
        "title": "Bérlethez rendelt rendszám. A törlése nem engedélyezett."
      }
    })])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addPlate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Új rendszám\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Access levels")]), _vm._v(" "), (_vm.form.access_level_ids.length > 0) ? _c('ul', {
    staticClass: "selected-tags"
  }, _vm._l((_vm.form.access_level_ids), function(id) {
    return _c('li', [_c('span', {
      on: {
        "click": function($event) {
          return _vm.accessLevelDel(id)
        }
      }
    }, [_vm._v("×")]), _vm._v(_vm._s(_vm.getAccessLevelTitle(id)))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('select2', {
    ref: "new_access_level_id",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Új access level",
      "name": "new_access_level_id",
      "id": "new_access_level_id",
      "options": _vm.new_access_levels
    },
    model: {
      value: (_vm.new_access_level_id),
      callback: function($$v) {
        _vm.new_access_level_id = $$v
      },
      expression: "new_access_level_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('label', {
    staticClass: "form-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "button small",
    attrs: {
      "disabled": _vm.new_access_level_id == 0,
      "type": "button"
    },
    on: {
      "click": _vm.addAccessLevel
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 1)])]), _vm._v(" "), (this.$route.query.cardID != undefined) ? _c('section', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Eseménynapló")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.logs), function(log, i) {
    return [(log.changes.access_levels.length || log.changes.plates.length) ? _c('tr', {
      key: 'log:' + i
    }, [_c('td', {
      style: (_vm.tdStyle(log))
    }, [_vm._v(_vm._s(log.name))]), _vm._v(" "), _c('td', {
      style: (_vm.tdStyle(log))
    }, [_vm._v(_vm._s(log.created))]), _vm._v(" "), _c('td', {
      style: (_vm.tdStyle(log))
    }, [_vm._l((log.changes.access_levels), function(change, i) {
      return _c('div', {
        key: 'change_access_level:' + i,
        staticStyle: {
          "padding": "4px",
          "margin-bottom": "1px"
        },
        attrs: {
          "title": _vm.getChangeTitle(change.action)
        }
      }, [_c('i', {
        class: {
          'fas fa-plus-circle': change.action === 'add', 'fas fa-minus-circle': change.action === 'remove'
        },
        style: ({
          color: _vm.getChangeBackground(change.action)
        })
      }), _vm._v("\n                          [Access Level] " + _vm._s(_vm.getAccessLevelNameByID(change.value)) + "\n                        ")])
    }), _vm._v(" "), _vm._l((log.changes.plates), function(change, i) {
      return _c('div', {
        key: 'change_plate:' + i,
        staticStyle: {
          "padding": "4px",
          "margin-bottom": "1px"
        },
        attrs: {
          "title": _vm.getChangeTitle(change.action)
        }
      }, [_c('i', {
        class: {
          'fas fa-plus-circle': change.action === 'add', 'fas fa-minus-circle': change.action === 'remove'
        },
        style: ({
          color: _vm.getChangeBackground(change.action)
        })
      }), _vm._v("\n                          [Rendszám] \"" + _vm._s(change.value) + "\"\n                        ")])
    })], 2)]) : _vm._e()]
  })], 2)])])])]) : _vm._e()])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Adminisztrátor")]), _vm._v(" "), _c('th', [_vm._v("Módosítva")]), _vm._v(" "), _c('th', [_vm._v("Változás")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729ddd5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/card.vue
// module id = 312
// module chunks = 0